import { createFileRoute } from '@tanstack/react-router';

import { TermsOfService } from '@/features/legal/TermsOfService';

/** `/terms` —— 服務條款（公開頁，不需登入）。 */
export const Route = createFileRoute('/terms')({
  component: TermsOfService,
});
